// extracted by mini-css-extract-plugin
module.exports = {"phoneEditor":"styles__phoneEditor___169yk"};